import { WithLayoutType } from '@sbercloud/uikit-product-utils';
import { Typography, TypographyProps } from '@snack-uikit/typography';
import { useMemo } from 'react';

import { BlogTypography } from '../BlogTypography';
import { QuotesSVG } from './QuotesSVG';
import styles from './styles.module.scss';

type QuoteProps = WithLayoutType<{
  text: string;
  name?: string;
  position?: string;
}>;

export function Quote(props: QuoteProps) {
  const { text, name, position, layoutType } = props;

  const typographyProps: TypographyProps = useMemo(() => {
    if (layoutType === 'mobile') {
      return {
        family: 'sans',
        purpose: 'body',
        size: 'm',
      };
    }

    return {
      family: 'sans',
      purpose: 'body',
      size: 'l',
    };
  }, [layoutType]);

  return (
    <div
      className={styles.quote}
      data-layout-type={layoutType}
      data-test-id="quote"
    >
      <div className={styles.iconWrapper} data-layout-type={layoutType}>
        <QuotesSVG className={styles.icon} />
      </div>
      <div className={styles.wrapper}>
        <BlogTypography
          className={styles.text}
          layoutType={layoutType}
          tag="p"
          type="body"
        >
          {text}
        </BlogTypography>
        <div className={styles.author}>
          {name && (
            <BlogTypography
              className={styles.name}
              layoutType={layoutType}
              tag="span"
              type="bodyBold"
            >
              {name}
            </BlogTypography>
          )}
          {position && (
            <Typography {...typographyProps} className={styles.position}>
              {position}
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
}
